import React, { useContext } from 'react';
import Context from 'context';
import { Colors, Position } from 'type';
import { Dot, Line } from './DotLine.style';

type DotLineProps = {
  dotPositions: Position[];
};

const DotLine = ({ dotPositions }: DotLineProps) => {
  const { colors } = useContext(Context);
  return (
    <>
      {dotPositions.map(({ x, y }) => (
        <Dot x={x} y={y} key={`${x}${y}`} color={colors[Colors.Secondary]} />
      ))}
      {dotPositions.length > 0 && (
        <Line
          x={dotPositions[0].x}
          y={dotPositions[0].y}
          height={dotPositions[dotPositions.length - 1].y - dotPositions[0].y}
          color={colors[Colors.Tertiary]}
        />
      )}
    </>
  );
};

export default DotLine;
